import { SELLER_STATUS_APPROVED, SELLER_STATUS_IN_DISPUTE, GRN_OR_FILTER_VALUES } from "../../../utils/constants/others";


export const DEFAULT_OR_FILTERS = [GRN_OR_FILTER_VALUES.SELLER_STATUS_NON_APPROVED];

export const GRN_OR_FILTERS = [
    {
        label: "Confirmation pending",
        value: GRN_OR_FILTER_VALUES.SELLER_STATUS_NON_APPROVED,
    },
    {
        label: "Confirmed",
        value: GRN_OR_FILTER_VALUES.SELLER_STATUS_APPROVED,
    },
    {
        label: "In dispute",
        value: GRN_OR_FILTER_VALUES.SELLER_STATUS_IN_DISPUTE,
    },
    {
        label: "Paid",
        value: GRN_OR_FILTER_VALUES.PAYMENT_STATUS_PAID,
    },
];

export function isInvoiceNumberValid(invoiceNumber) {
    if (invoiceNumber?.length <= 0) {
        return true
    }

    const invoiceNumberRegex = /^[0-9a-zA-Z/\-\\.#_()|&]{1,50}$/;
    return invoiceNumberRegex.test(invoiceNumber);
}

export function isGrnSellerStatusApproved(sellerStatus) {
    return SELLER_STATUS_APPROVED == sellerStatus || SELLER_STATUS_IN_DISPUTE == sellerStatus
}
